// src/config/firebase.ts
import { initializeApp, getApps, getApp, type FirebaseApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY || "",
  authDomain: process.env.REACT_APP_AUTHDOMAIN || "",
  databaseURL: process.env.REACT_APP_DATABASEURL || "",
  projectId: process.env.REACT_APP_PROJECTID || "",
  storageBucket: process.env.REACT_APP_STORAGEBUCKET || "",
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID || "",
  appId: process.env.REACT_APP_APPID || "",
  measurementId: process.env.REACT_APP_MEASUREMENTID || "",
};

const requiredKeys = [
  "REACT_APP_API_KEY",
  "REACT_APP_AUTHDOMAIN",
  "REACT_APP_PROJECTID",
  "REACT_APP_STORAGEBUCKET",
  "REACT_APP_MESSAGINGSENDERID",
  "REACT_APP_APPID",
];

const missingKeys = requiredKeys.filter((key) => {
  const value = process.env[key];
  return !value || !String(value).trim();
});

if (missingKeys.length > 0) {
  // eslint-disable-next-line no-console
  console.warn(
    `[firebase] Missing Firebase env values: ${missingKeys.join(", ")}`
  );
}

const app: FirebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);

export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: "select_account",
});

export default app;